/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { FlexRow, FlexCol, Carousel, useWindowSize } from 'sarsaparilla';
import { ItemsPlaceholder } from './ItemsPlaceholder';
import ContestCard from '../ContestCard';
import { slugify } from '../../utils/storyUtils';

export default function Finalists({
    items,
    isLoading,
    //tag
}) {
    const { width } = useWindowSize();

    if (isLoading) {
        return (
            <FlexRow>
                {[...Array(16)].map((x, i) => (
                    <ItemsPlaceholder key={i} />
                ))}
            </FlexRow>
        );
    }

    return (
        <FlexRow>
            <FlexCol className="mb-4">
                <Carousel
                    className="sarsa-tall-carousel-wrap"
                    slideTargetWidth={275}
                    hasGutters
                    hasNegativeMargins={width > 1240}
                    hasPaddingBelow
                >
                    {items.map((item) => {
                        let media = {};
                        if (item.media?.length > 0) {
                            media = item.media[0];
                        }

                        const locations =
                            item.locations?.map((l) => {
                                return l.location_name;
                            }) || [];

                        return (
                            <ContestCard
                                key={`recent-${item.story_id}`}
                                imagePath={media.url}
                                imageAlt={media.title}
                                href={`/shareyourstory/story/${slugify(item.title)}/${item.story_id}`}
                                heading={item.title}
                                locations={locations}
                                categoryTags={[item.final_category]}
                                author={`${item.first_name} ${item.last_name}`}
                                submissionDate={
                                    item.submitted_date
                                        ? format(
                                              new Date(item.submitted_date),
                                              'MMMM dd, yyyy'
                                          )
                                        : ''
                                }
                                winnerTags={item.prizes_objs || []}
                            />
                        );
                    })}
                </Carousel>
            </FlexCol>
        </FlexRow>
    );
}

Finalists.propTypes = {
    items: PropTypes.array,
    isLoading: PropTypes.bool,
    //tag: PropTypes.string
};
